module.exports = __webpack_public_path__ + "static/media/day10.workshop.6beb31d0.md";